import { useEffect, useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import React from "react";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { CreateDiscountDialog } from "./CreateDiscountDialog";
import { EditDiscountDialog } from "./EditDiscountDialog";
import { ICONS } from "../../utils/icons";

export const Discounts = ({ event, setEvent, handleSnackbar }) => {
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [discount, setDiscount] = useState();
  const [discounts, setDiscounts] = useState([]);

  const handleOpenCreatePopup = () => {
    setOpenCreateDialog(true);
  };

  const handleOpenEditPopup = (name) => {
    setDiscount(name);
    setOpenEditDialog(true);
  };

  useEffect(() => {
    event?.ticket_discounts
      ? setDiscounts(
          Object.keys(event?.ticket_discounts).map((item) => {
            return {
              ...event?.ticket_discounts[item],
            };
          })
        )
      : setDiscounts([]);
  }, [event]);

  return (
    <div>
      {openEditDialog && (
        <EditDiscountDialog
          openPopup={openEditDialog}
          setOpenPopup={setOpenEditDialog}
          discount={discount}
          discounts={event.ticket_discounts}
          handleSnackbar={handleSnackbar}
          event={event}
          setEvent={setEvent}
        />
      )}
      {openCreateDialog && (
        <CreateDiscountDialog
          openPopup={openCreateDialog}
          setOpenPopup={setOpenCreateDialog}
          category={discount}
          discounts={event.ticket_discounts}
          handleSnackbar={handleSnackbar}
          event={event}
          setEvent={setEvent}
        />
      )}
      <div style={{ height: "20px" }} />
      <div className="standard-container" style={{ marginBottom: "20px" }}>
        <h2>Manage discount codes</h2>
        <p id="subTitle" style={{ marginBottom: "20px" }}>
          Your live overview of all discount codes
        </p>
        <MainButton
          text={"Create new discount code"}
          color={COLORS.black}
          hoverColor={COLORS.black}
          textColor={COLORS.white}
          borderColor={COLORS.black}
          shadowColor={COLORS.mainAccent}
          textHoverColor={COLORS.lightGrey}
          onClickAction={() => handleOpenCreatePopup()}
          width={"fit-content"}
        >
          {ICONS.plus20}
        </MainButton>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {discounts.length == 0 && <p>No discounts created</p>}
        {discounts?.map((discount, index) => (
          <div
            key={index}
            className="small-container"
            style={{
              height: "105px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    fontFamily: "DrukWideCy",
                    fontSize: "18px",
                  }}
                >
                  {discount?.code}
                </p>
                <p id="subheader">
                  Amount: {discount?.discount_amount} {discount?.discount_type}
                </p>
                <p id="subheader">Used: {discount?.current_usage} times</p>
              </div>
              {ICONS.discount20Grey}
            </div>
            <div className="container-row" style={{ marginTop: "15px" }}>
              <MainButton
                text={"Edit"}
                color={"transparent"}
                hoverColor={"transparent"}
                textColor={COLORS.black}
                borderColor={COLORS.black}
                shadowColor={COLORS.mainAccent}
                textHoverColor={COLORS.grey}
                onClickAction={() => handleOpenEditPopup(discount)}
                width={"fit-content"}
              >
                {<AiOutlineEdit size={20} />}
              </MainButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
